"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasExternalProperty = hasExternalProperty;
exports.hasTopicCount = hasTopicCount;
exports.hasVisibleTopicsCount = hasVisibleTopicsCount;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * @deprecated Consider migrating to `@insided/shared/utils/categories` Category or CategoryLite structure
 */
// Simplified interface for custom dropdown menu items
// No need to extend Category since we have a dedicated component

/**
 * Configuration for segment-based visibility of mega-menu items
 * - enabled=false → visible to everyone
 * - enabled=true + no segments → visible to everyone
 * - enabled=true + segments → only users in those segments can see it
 */
function hasExternalProperty(category) {
  return category && (0, _typeof2.default)(category) === 'object' && 'external' in category;
}

function hasTopicCount(category) {
  return 'topicCount' in category;
}

function hasVisibleTopicsCount(category) {
  return 'visibleTopicsCount' in category;
}